<template>
  <div>
    <h2 class="text-h6">{{ header }}</h2>
    <h3 class="h4 subtitle mb-4">{{ description }}</h3>
    <div class="redactor-wrapper">
      <vue-redactor v-model="content" @changeMade="setChangeMade" @enableSave="setEnableSave" />
    </div>
    <c-button-group>
      <c-button :disabled="!enableSave || !changeMade" color="primary" @click="save">
        <c-spinner v-if="isSaving" color="success" size="sm" />
        <span v-else>{{ buttonText }}</span>
      </c-button>
      <c-button v-if="showCancelButton" color="secondary" :disabled="isSaving" @click="cancelEdit">Cancel</c-button>
    </c-button-group>
  </div>
</template>

<script>
import _ from 'lodash';
import VueRedactor from '../../components/vue-redactor';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'EditEmailText',
  components: {
    VueRedactor,
  },
  props: {
    organisation: Object,
    textType: String,
    header: String,
    description: String,
    buttonText: String,
  },
  data() {
    return {
      error: null,
      isSaving: false,
      success: false,
      showCancelButton: false,
      changeMade: false,
      enableSave: false,
      content: null,
    };
  },
  created() {
    this.setData();
  },
  methods: {
    setData() {
      if (this.textType === 'header') {
        this.content = _.get(this.organisation, 'config.email.globalHeaderText');
      } else if (this.textType === 'footer') {
        this.content = _.get(this.organisation, 'config.email.globalFooterText');
      }
    },
    cancelEdit() {
      this.setData();
      this.resetButtonState();
    },
    resetButtonState() {
      this.showCancelButton = false;
      this.enableSave = false;
      this.changeMade = false;
    },
    setChangeMade() {
      this.showCancelButton = true;
      this.changeMade = true;
      this.enableSave = true;
    },
    setEnableSave(payload) {
      this.enableSave = payload;
    },
    disableSave() {
      this.enableSave = false;
    },
    save() {
      this.isSaving = true;
      this.error = null;

      const data = {
        id: this.organisation._id,
        text: this.content,
        textType: this.textType,
      };

      this.$http
        .post(buildEndpoint('organisation-admin/organisation/email/update-email-text'), data)
        .then((response) => {
          this.isSaving = false;
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'Email text saved',
            });
            if (this.textType === 'header') {
              _.set(this.organisation, 'config.email.globalHeaderText', this.content);
            } else if (this.textType === 'footer') {
              _.set(this.organisation, 'config.email.globalFooterText', this.content);
            }
            this.resetButtonState();
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: 'Error saving email content',
            });
          }
        })
        .catch((error) => {
          this.isSaving = false;
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped="">
.redactor-wrapper {
  margin-bottom: 20px;
}
</style>
